module.exports = __webpack_public_path__ + "media/ש.a6c667b6.mp3";